module.exports = __webpack_public_path__ + "img/vsdigisignature.083d67ed.png";